// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__40BW5","modal":"Modal_modal__UrjZK","modalClose":"Modal_modalClose__2dvCu"};